export default __webpack_public_path__ + "img/stage2.b0c52a2f.jpg";